// extracted by mini-css-extract-plugin
export default {"thumbnail-wrapper":"styles_thumbnail-wrapper__ptFRn","thumbnail-image":"styles_thumbnail-image__gxFwz","counter-overlay":"styles_counter-overlay__ytEWb"};